// extracted by mini-css-extract-plugin
export default {"modal":"LongCruiseModal__modal___urQOr"};